

































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { ReferralCount } from '@/api/types'
const referrals = namespace('referrals')

@Component
export default class LegacyReferralCharts extends Vue {
    @referrals.State readonly loading!: boolean
    @referrals.State readonly referralCounts!: ReferralCount

    get hasChartAgeData(): boolean {
        return (
            this.referralCounts.age90 +
            this.referralCounts.age180 +
            this.referralCounts.age365
        ) > 0
    }

    get hasChartScoreData(): boolean {
        return (
            this.referralCounts.scorePositive +
            this.referralCounts.scoreNeutral +
            this.referralCounts.scoreNegative
        ) > 0
    }

    get hasChartTypesData(): boolean {
        return (
            this.referralCounts.typeAppraisal +
            this.referralCounts.typeEpa +
            this.referralCounts.typeInformation +
            this.referralCounts.typeMortgage +
            this.referralCounts.typePurchase +
            this.referralCounts.typePhoto +
            this.referralCounts.typeSale +
            this.referralCounts.typeSignPlacement +
            this.referralCounts.typeTaxation +
            this.referralCounts.typeTechnicalAppraisal +
            this.referralCounts.typeNewBuild
        ) > 0
    }

    get hasAnyChartData(): boolean {
        return this.hasChartAgeData || this.hasChartScoreData || this.hasChartTypesData
    }
}
